"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconFlag = function SvgIconFlag(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "flag icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Flag Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.84 13c-.327-.334-.818-.667-1.31-.667h-9.829v-5c0-1-.655-1.666-1.637-1.666H10.042C10.043 4.667 9.388 4 8.406 4c-.985 0-1.64.666-1.64 1.666v36.668c0 1 .656 1.666 1.639 1.666s1.638-.666 1.638-1.666V29h6.553v5.5c0 .167 0 .167.163.334V35l.165.167c.163.167.327.167.491.333h.164c.327.167.492.167.656.167H39.53c.491 0 .982-.333 1.31-.667.328-.5.328-1 .163-1.5L38.055 24l3.114-9.5c.164-.5 0-1-.327-1.5zM10.045 9h16.382v16.665H10.045V9zM22.66 29l-2.786 1.834V29zm12.122-4.5l2.62 7.833H23.805l5.406-3.667.164-.166c.164-.167.164-.333.327-.5v-.167c0-.166.164-.333.164-.5V15.668h7.536L34.78 23.5a1.079 1.079 0 000 1z"
  }));
};

var _default = SvgIconFlag;
exports.default = _default;